#import "../fragments/ai-email-template.graphql"

query GetAiGeneratedTemplateByEdition($editionId: ID!) {
    aiGeneratedTemplateGet(editionId: $editionId) {
        ...AiEmailTemplate
    }
}
